import { getHeaders } from "./api";
import { AssessmentsDocument } from "../components/CompanyAssessments/assessmentsTypes";
import { normalizeDocument } from "../components/CompanyAssessments/assessmentsMutations";

const BACKEND_URI = ((import.meta as any)?.env?.VITE_BACKEND_URI ?? "").replace(/\/$/, "");

export async function getCompanyAssessmentsApi(
    idToken: string | undefined
): Promise<AssessmentsDocument> {
    const headers = await getHeaders(idToken);
    const response = await fetch(`${BACKEND_URI}/my-company/assessments`, {
        method: "GET",
        headers: { ...headers },
        credentials: "same-origin"
    });
    if (!response.ok) {
        throw new Error(`Request failed with status ${response.status}: ${response.statusText}`);
    }
    const data = await response.json();
    return normalizeDocument(data.assessments);
}

export async function updateCompanyAssessmentsApi(
    payload: AssessmentsDocument,
    idToken: string | undefined
): Promise<AssessmentsDocument> {
    const headers = await getHeaders(idToken);
    const response = await fetch(`${BACKEND_URI}/my-company/assessments`, {
        method: "PUT",
        headers: { ...headers, "Content-Type": "application/json" },
        body: JSON.stringify(payload),
        credentials: "same-origin"
    });
    if (!response.ok) {
        let message = `Request failed with status ${response.status}`;
        try {
            const data = await response.json();
            if (data?.error) message = data.error;
        } catch {
            /* fall through */
        }
        throw new Error(message);
    }
    const data = await response.json();
    return normalizeDocument(data.assessments);
}
